<script>
import Endpoints from '../../../../components/common/Endpoints';
import Common from '../../../../components/common/Common';
import Request from '../../../../components/common/Request';

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
        payload.filter();
    },
    methods:{
        filter: function(){
            let state = this;
            state.items = [];
            setTimeout(async function(){
                let services = (await Request.do(state, 'POST', Request.getDefaultHeader(state),{}, `${Endpoints.orders.holder.listServices}`));
                state.items = JSON.parse(JSON.stringify(services.data.results));
            }, 100);
            
        },
        onChange: function(items){
            if(items){
                this.partionalResults = items.item.sort(function(a, b){return b.countOrders - a.countOrders});          
            }
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>
